import React from 'react';

import TableHeader from '../Stats/TableHeader';
import TableRows from '../Stats/TableRows';

import StyledStatsOffice from './styles/StyledStatsOffice';
import StyledStatsTable from '../Stats/styles/StyledStatsTable';


const StatsOfficeView = ({
  statsData,
}) => (
  <StyledStatsOffice>
    <StyledStatsTable>
      <TableHeader />
      <TableRows statsData={statsData} />
    </StyledStatsTable>
  </StyledStatsOffice>
);


export default StatsOfficeView;
